

<h3>
    Personal Role Management
</h3>
<div>
    <strong>
        <p>
            Review your current application roles and permissions, request new roles, or remove roles you no longer need. For assistance, please review the <a href="https://education.ohio.gov/getattachment/Miscellaneous/Application-Role-Management-ARM-Tool/Role-Request-User-Guide-Personal-Management.pdf.aspx?lang=en-US" target="_blank">Personal Role Management User Guide</a>.
        </p>
    </strong>
</div>

<app-multi-org-filter></app-multi-org-filter>

<div>
    <ul class="tile-container fade">
        <li>
            <a href="javascript:void(0)" [ngClass]="isOrgSelected || hasNoOrgs ? '':'disabled'" (click)="routeTo('role-overview')" 
                class="a--tile tile--lrg white hover--shadow" style="border-radius:calc(8px)">
                <div class="tile--img">
                    <div class="img--position">
                        <i class="fa-solid fa-file-invoice"></i>
                    </div>
                </div>
                <div class="tile--content">
                    <header class="header--tile">
                        <div class="tile--title">Role Overview</div>
                    </header>
                    <p class="p--tile">
                        Review the application roles and permissions assigned to you.
                    </p>
                </div>
            </a>
        </li>
        <li>
            <a href="javascript:void(0)" [ngClass]="isOrgSelected || hasNoOrgs ? '':'disabled'" (click)="routeTo('request-new-role')" 
                class="a--tile tile--lrg white hover--shadow" style="border-radius:calc(8px)">
                <div class="tile--img">
                    <div class="img--position">
                        <i class="fa-solid fa-user-plus"></i>
                    </div>
                </div>
                <div class="tile--content">
                    <header class="header--tile">
                        <div class="tile--title">Request New Role</div>
                    </header>
                    <p class="p--tile">
                        Request new application roles and permissions.
                    </p>
                </div>
            </a>
        </li>
        <li>
            <a href="javascript:void(0)" [ngClass]="isOrgSelected || hasNoOrgs ? '':'disabled'" (click)="routeTo('remove-role')" class="a--tile tile--lrg white hover--shadow"
                style="border-radius:calc(8px)">
                <div class="tile--img">
                    <div class="img--position">
                        <i class="fa-solid fa-user-minus"></i>
                    </div>
                </div>
                <div class="tile--content">
                    <header class="header--tile">
                        <div class="tile--title">Remove Role</div>
                    </header>
                    <p class="p--tile">
                        Remove application roles that you no longer need.
                    </p>
                </div>
            </a>
        </li>
    </ul>
    <ng-container *ngIf="isOrgSelected || hasNoOrgs">
        <div *ngIf="loading" style="padding: 20px; display: flex; justify-content: center;">
            <h3>loading...</h3>
        </div>
    
        <ng-container *ngIf="showMangeRequest || showAddRemoveRole">
            <div class="font-24">
                Administrator Role Management
            </div>
            <div class="border-bottom border-gray-600 ptb-20">
                
                <strong>
                    Manage the application roles for employees in your organization. For assistance, please review the <a href="https://education.ohio.gov/getattachment/Miscellaneous/Application-Role-Management-ARM-Tool/Role-Request-User-Guide-Administrator-Management.pdf.aspx?lang=en-US" target="_blank">Administrator Role Management User Guide</a>.
                </strong>
            </div>
            <ul class="tile-container fade">
                <li *ngIf="showMangeRequest">
                    <a href="javascript:void(0)" [ngClass]="isOrgSelected ? '':'disabled'" (click)="routeTo('manage-role-request')" 
                        class="a--tile tile--lrg white hover--shadow" style="border-radius:calc(8px)">
                        <div class="tile--img">
                            <div class="img--position">
                                <i class="fa-sharp fa-solid fa-people-roof"></i>
                            </div>
                        </div>
                        <div class="tile--content">
                            <header class="header--tile">
                                <div class="tile--title">Manage Request</div>
                            </header>
                            <p class="p--tile">
                                View, approve and deny pending requests for application roles and permissions.
                            </p>
                        </div>
                    </a>
                </li>
                <li *ngIf="showAddRemoveRole">
                    <a href="javascript:void(0)" [ngClass]="isOrgSelected ? '':'disabled'" (click)="routeTo('add-employee-role')" 
                        class="a--tile tile--lrg white hover--shadow" style="border-radius:calc(8px)">
                        <div class="tile--img">
                            <div class="img--position">
                                <i class="fa-solid fa-user-tie"></i>
                            </div>
                        </div>
                        <div class="tile--content">
                            <header class="header--tile">
                                <div class="tile--title">Add Employee Role</div>
                            </header>
                            <p class="p--tile">
                                Add application roles and permissions to people in your organization.
                            </p>
                        </div>
                    </a>
                </li>
                <li *ngIf="showAddRemoveRole">
                    <a href="javascript:void(0)" [ngClass]="isOrgSelected ? '':'disabled'" (click)="routeTo('remove-employee')" 
                        class="a--tile tile--lrg white hover--shadow" style="border-radius:calc(8px)">
                        <div class="tile--img">
                            <div class="img--position">
                                <i class="fa-solid fa-users-gear"></i>
                            </div>
                        </div>
                        <div class="tile--content">
                            <header class="header--tile">
                                <div class="tile--title">Remove Employee Role</div>
                            </header>
                            <p class="p--tile">
                                Remove application roles and permissions from people in your organization.
                            </p>
                        </div>
                    </a>
                </li>
                <li>
                    <a href="javascript:void(0)" [ngClass]="isOrgSelected ? '':'disabled'" (click)="routeTo('employee-role-overview')" 
                        class="a--tile tile--lrg white hover--shadow" style="border-radius:calc(8px)">
                        <div class="tile--img">
                            <div class="img--position">
                                <i class="fa-solid fa-users"></i>
                            </div>
                        </div>
                        <div class="tile--content">
                            <header class="header--tile">
                                <div class="tile--title">Employee Role Overview</div>
                            </header>
                            <p class="p--tile">
                                Review the application roles and permissions assigned to people in your organization.
                            </p>
                        </div>
                    </a>
                </li>
            </ul>
        </ng-container>
    </ng-container>
</div>
